import styled from 'styled-components/macro';
import { VerticalCenter } from '../../../../shared-styles';

export const IconContainer = styled.div`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  ${(props) => (props.onClick ? `
    :hover {
      cursor: pointer;
    }
  ` : '')}
  ${(props) => (!props.offCenter ? VerticalCenter : '')}
`;
